import axios from 'axios'
// import md5 from "js-md5";
import qs from 'qs';
import config from '../../config/config'
import Util from '../util/util'
let _util = new Util()

let Base64 = require('js-base64').Base64

import {
  getToken
} from '@/axios/auth'
import router from '@/router/index'
import {
  Message,
  MessageBox
} from 'element-ui'

let baseURL = config.baseUrl; // 生产
let baseUrlLog = config.baseUrlLog
let userInfo = _util.getStorage('ssoUserInfo')
let onoff = true
function getCookie(name){
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == name){
          return arr[1];
      }
  }
  return "";
}

// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  withCredentials: true,
//   timeout: 10000, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    const index = config.url.indexOf('/api')
    const url = config.url.slice(index)
    console.log(config.baseURL.indexOf(':8080'))
    if(url == "/api/login" || url == '/api/assess/updateSpreadProportion' || url == '/api/kpi/updateLeaderScore'|| url == '/api/mediaAnalysis/exportMediaAnalysisInfo' || url == '/api/user/validatePassword') {
      console.log(_util.getStorage('ssoUserInfo').accountId)
      config.headers = {
        'content-type': 'application/x-www-form-urlencoded;',
        'ACCESSTOKEN': _util.getStorage('ssoUserInfo').accessToken,
        'ZHXGUSERID': Base64.encode(_util.getStorage('ssoUserInfo').accountId),
        'verifyCode' :getCookie('verifyCode')    
      };
    } 
    else if ( config.baseURL.indexOf(':8080') < 0 && config.url == '/api/LogSearch/LogSearchList') { // 日志审计请求地址 -- 测试
      config.baseURL = baseUrlLog
    } 
    else {
      config.headers = {
        'ACCESSTOKEN': _util.getStorage('ssoUserInfo').accessToken,
        'ZHXGUSERID': Base64.encode(_util.getStorage('ssoUserInfo').accountId),
        'content-type': 'application/json;charset=utf-8'
      };
    }
    return config
  },
  error => {
    // Do something with request error
    Message({
      //  饿了么的消息弹窗组件,类似toast
      showClose: true,
      message: error,
      type: "error.data.error.message"
    });
  return Promise.reject(error.data.error.message);
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      // console.log(response.data)
      if(response.data.code == 401) {
        if(onoff) {
          Message({
            message: response.data.msg,
            type: 'error',
            duration: 2000
          })
          setTimeout(() => {
            router.push({
              path: '/'
            })    
          },3000)

          onoff = false         
        }
      } else  {
        return response.data;
      }
      
    } else if(response.status == 400) {

    //   Message({
    //     message: res.message,
    //     type: 'error',
    //     duration: 2000
    //   })
    }
  },
  error => {
    // console.log(error,'-----------')
    Message({
      message: error,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/request.js